module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAYAAAByDd+UAAAAAXNSR0IArs4c6QAAAPRJREFUSA3NlAEOwyAIRc0uufvfY8vGN7JZi/phNBlJ01bhPW0N5fWNhzzeS3KAKRfYNYo+tHuqVJgHGRwQfuwYkEiRCuckAxtCcwLj0a+7ZW4THGaaRScu5G6Gu6CTh2sjhZGabq3FdZB+lqmZATE5yqPuK+BqjoLPkibgp4zj6iOlYdR1CNVqDtfIdOdNOu4KUozRXemmwL+6t92NTR6707j8/11zaGT51mGpu1nNhX4PA2RyKLkH5Mk15RFApKbKw4VS7a51Fxjfh2bQiYZkHNqytgkjkXhfMmVy7CApXWMmxc/uI0WmH0HAp8bRC1NlM+kbnhYBilEsGs4AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./static/close-read.png
// module id = gz6g
// module chunks = 0